import { apiRoutes } from "routes";
import FetchHelpers from "utils/FetchHelpers";

export default {
  getToken(params, separator) {
    const url = apiRoutes.oauthTokenPath(1);
    return FetchHelpers.post(url, params, separator);
  },

  revokeToken(params) {
    const url = apiRoutes.oauthRevokePath(1);
    return FetchHelpers.post(url, params);
  },
};
